export default "__VITE_ASSET__Dh$UUpIk__"